module.exports = __webpack_public_path__ + "static/img/MV19.f5bf39d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV19.jpg
// module id = xaBp
// module chunks = 0